// extracted by mini-css-extract-plugin
export default {"page":"page-fbZsr","is-active":"is-active-Pjpop"};